import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CHANGE_DCA_PERCENT,
  CHANGE_DCA_TRIGGER,
  CHANGE_FREQUENCY,
} from "../../../../actions/create-bot-type";
import DcaMartingaleView from "./DcaMartingaleView";
import LeftRightForm from "../modules/LeftRightForm";
import { Form } from "react-bootstrap";
import CustomRadio from "../modules/CustomRadio";
import { restrictAlphabets } from "../../../../utils/Utils";
import AddIndicatorView from "../AddIndicatorView";
import SliderView from "../SliderView";
import TutorialPopup from "../../../help/TutorialPopup";
import { Frequencies, FrequenciesProDca, FrequencyValues, FrequencyValuesProDca } from "../../../../Const";
import { isPro } from "../../../../utils/SubUtils";

const DcaPercentEntry = (props) => {
  const { newBot, isBuy,t } = props;
  const frequency = newBot.frequency;
  const subscription = useSelector(
    (state) => state.auth.user.user_subscription
  );
  const dcaTrigger = newBot.dcaTrigger;
  const side = isBuy ? "Buy" : "Sell";
  const isProffessional = isPro(subscription)
  const dispatch = useDispatch();
  const changeDcaPercent = (val) => {
    dispatch({
      type: CHANGE_DCA_PERCENT,
      payload: val,
    });
  };

  const changeDcaTrigger = (val) => {
    dispatch({
      type: CHANGE_DCA_TRIGGER,
      payload: val,
    });
  };
   const frequencyChanged = (val) => {
    console.log(val)
      dispatch({
        type: CHANGE_FREQUENCY,
        payload: val,
      });
    };
    const formartFrequency = (value) => isProffessional?FrequenciesProDca[value]:Frequencies[value];
  return (
    <div>
      <LeftRightForm 
        left={<h6 className="font-weight-bold">First {side}</h6>}
        right={<>
          <CustomRadio
            type="radio"
            name="first_buy"
            label={<>{side} Immediately when Bot is Created</>}
            val={"0"}
            checked={dcaTrigger === "0"}
            callback={() => changeDcaTrigger("0")}
          ></CustomRadio>
          <div className="d-flex">
          <CustomRadio
            type="radio"
            name="first_buy"
            label={<>{side} When Price Reaches</>}
            val={dcaTrigger}
            checked={dcaTrigger == "1"}
            callback={() => changeDcaTrigger("1")}
          ></CustomRadio>
          
          <label data-text={newBot.quoteCoin} className="dca input-gp-label">
              <Form.Control
                  as="input"
                  type="number"
                  value={dcaTrigger}
                  onChange={(e) => changeDcaTrigger(Number(e.target.value))}
                  onKeyPress={(e) => {
                    restrictAlphabets(e);
                  }}
                  className="input-text input-gp-tex dca-buydown-text"
                ></Form.Control>
          </label>
          
          </div>
          <CustomRadio
            type="radio"
            name="first_buy"
            label={<>Indicator</>}
            val={"oscillator"}
            checked={dcaTrigger === "oscillator"}
            callback={() => changeDcaTrigger("oscillator")}
          ></CustomRadio>
          {dcaTrigger === "oscillator" &&
            <>
            <AddIndicatorView newBot={newBot} isEntry={true} t={t}/>
           
            </>
          }
          
          
        </>
        
       }
      
      ></LeftRightForm>
      {dcaTrigger === "oscillator" &&
       <div style={{ marginTop: 20 }}>
            {!isPro?<> 
            <SliderView
              title={t("tf")}
              max={4}
              value={FrequencyValues.indexOf(frequency) < 0 ? FrequencyValues.indexOf(15) : FrequencyValues.indexOf(frequency)}
              formatLabel={formartFrequency}
              onChange={(value) => frequencyChanged(FrequencyValues[value])}
              tutorial={<TutorialPopup content={t("trading-freq-help")}  />}
            />
            </>:<>
            <SliderView
              title={t("tf")}
              max={5}
              value={FrequencyValuesProDca.indexOf(frequency) < 0 ? FrequencyValuesProDca.indexOf(5) : FrequencyValuesProDca.indexOf(frequency)}
              formatLabel={formartFrequency}
              onChange={(value) => frequencyChanged(FrequencyValuesProDca[value])}
              tutorial={<TutorialPopup content={t("trading-freq-help")}  />}
            />
            </>}
          </div>
      }
      <LeftRightForm
        left={<h6 className="font-weight-bold">Subsequent {side}s</h6>}
        right={
          <div className="d-flex align-items-center">
          <div>{side} every time when price {isBuy ? "drops" : "rises"} by{" "}</div>
          <div> 
            <label data-text={'%'} className="dca input-gp-label">
              <Form.Control
                  as="input"
                  type="number"
                  value={newBot.dcaPercent}
                  onChange={(e) => changeDcaPercent(e.target.value)}
                  onKeyPress={(e) => {
                    restrictAlphabets(e);
                  }}
                  className="input-text input-gp-tex dca-subseq-text"
                ></Form.Control>
            </label>
          </div>
            <div>
            from last {side} Price
            </div>
          </div>
          
        }
      ></LeftRightForm>
      <DcaMartingaleView dcaMartingale={newBot.dcaMartingale} isBuy={isBuy} t={t} />
    </div>
  );
};

export default DcaPercentEntry;
